import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Landing from "./pages/Landing";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Blog from "./pages/Blog";
import Payment from "./pages/Payment";
import Support from "./pages/Support";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import DashboardSettings from "./pages/DashboardSettings";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import Users from "./pages/Users";
import UserEdit from "./pages/UserEdit";
import SetPassword from "./pages/SetPassword";

const queryClient = new QueryClient();

const ReportsRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate to={`/dashboard/reports${search}${hash}`} replace />;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    {/* Mount one global TooltipProvider at the app root */}
    <TooltipProvider delayDuration={150} disableHoverableContent>
      <Toaster />
      <Sonner />
      <BrowserRouter basename="/">
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            {/* If you want a public landing page at "/", move Navigate or change path */}
            <Route path="/landing" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/support" element={<Support />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/reports" element={<ReportsRedirect />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            >
              <Route path="projects" element={<Projects />} />
              <Route path="projects/:id" element={<Project />} />
              <Route path="settings" element={<DashboardSettings />} />
              <Route path="users" element={<Users />} />
              {/* If this is an edit page, you likely want :id */}
              <Route path="users/:id" element={<UserEdit />} />
              <Route path="reports" element={<Reports />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
